import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

var StatusHelper =
/*#__PURE__*/
function () {
  function StatusHelper() {
    _classCallCheck(this, StatusHelper);

    _defineProperty(this, "STATUSES", {
      NOT_SUBMITTED: {
        label: "Not Submitted",
        value: 1
      },
      NOT_REVIEWED: {
        label: "Submitted",
        value: 2
      },
      UNDER_REVIEW: {
        label: "Under Review",
        value: 3
      },
      REVIEWED: {
        label: "Reviewed",
        value: 4
      },
      APPROVED: {
        label: "Approved",
        value: 5
      },
      REJECTED: {
        label: "Rejected",
        value: 6
      }
    });
  }

  _createClass(StatusHelper, [{
    key: "GetStatusArray",
    value: function GetStatusArray() {
      var isScheduled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var result = [this.STATUSES.NOT_SUBMITTED, this.STATUSES.NOT_REVIEWED, this.STATUSES.UNDER_REVIEW, this.STATUSES.REVIEWED, this.STATUSES.APPROVED];

      if (isScheduled == false) {
        result.push({
          label: "Denied",
          value: 6
        });
      } else result.push(this.STATUSES.REJECTED);

      return result;
    }
  }, {
    key: "GetStatusArrayByTask",
    value: function GetStatusArrayByTask(task) {
      if (task == "AFS" || task == "BUDGET") return [this.STATUSES.NOT_SUBMITTED, this.STATUSES.NOT_REVIEWED, this.STATUSES.UNDER_REVIEW, this.STATUSES.REVIEWED, this.STATUSES.APPROVED, {
        label: "Non-Compliant",
        value: 6
      }];else return [this.STATUSES.NOT_SUBMITTED, this.STATUSES.NOT_REVIEWED, this.STATUSES.UNDER_REVIEW, this.STATUSES.REVIEWED, this.STATUSES.APPROVED, this.STATUSES.REJECTED];
    }
  }, {
    key: "GetStatusLabel",
    value: function GetStatusLabel(id) {
      var isScheduled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (id == -1) return "Not Started";
      if (id < 1 || id > this.GetStatusArray().length) return this.GetStatusArray()[0].label;
      var status = this.GetStatusArray()[id - 1];
      if (isScheduled == false && id == 6) return "Denied";
      return status ? status.label : null;
    }
  }, {
    key: "GetStatusLabelWithPreviouslySumbitted",
    value: function GetStatusLabelWithPreviouslySumbitted(id, hasBeenSubmitted) {
      if (id == -1) return "Not Started";
      if (id < 1 || id > this.GetStatusArray().length) return this.GetStatusArray()[0].label;
      var status = this.GetStatusArray()[id - 1];
      if (status == this.STATUSES.NOT_SUBMITTED && hasBeenSubmitted == true) return "Unsubmitted";
      return status ? status.label : null;
    }
  }, {
    key: "GetStatusLabelByTask",
    value: function GetStatusLabelByTask(id, task) {
      if (id == -1) return "Not Started";
      if (id == 6 && (task == "AFS" || task == "BUDGET")) return "Non-Compliant";else if (id < 1 || id > this.GetStatusArray().length) return this.GetStatusArray()[0].label;
      var status = this.GetStatusArray()[id - 1];
      return status ? status.label : null;
    }
  }]);

  return StatusHelper;
}();

export default new StatusHelper();